import { render } from "./CampaignSubidControls.vue?vue&type=template&id=0b06b872&ts=true&lang=pug"
import script from "./CampaignSubidControls.vue?vue&type=script&lang=ts"
export * from "./CampaignSubidControls.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__